import * as prismic from '@prismicio/client';

const endpoint = prismic.getRepositoryEndpoint('landsbankinn');

export const client = prismic.createClient(endpoint, {
  // Using public api so no need for accessToken
  accessToken: '',
});
